'use client';

import { Accordion } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

const StyledAccordion = styled(Accordion)`
  margin-top: ${({ theme }) => theme.spacing[400]};

  summary,
  summary + div {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  summary,
  summary span,
  summary svg {
    position: sticky;
    left: 0;
  }

  summary {
    &:hover {
      text-decoration: none !important;
    }

    svg {
      fill: ${({ theme }) => theme.color.icon.base};
    }

    span {
      flex-grow: unset !important;
      left: 2rem;
      color: ${({ theme }) => theme.color.font.interactiveBase};

      & + span {
        left: ${({ theme }) => theme.spacing[500]};
      }
    }
  }

  details {
    border-top: none !important;

    &[open] {
      border-bottom: none;
    }
  }
`;

export { StyledAccordion };
